import React from 'react';
import Truck from '../../components/Buttons/TruckButton.jsx';
import AlertActions from '../../reflux/AlertActions';

export default class Proveedores extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const Trucks = (
            <Truck 
                iconProps={{color:"white"}}/>
            );
        AlertActions.configureAppBar('Proveedores', null, Trucks);
    }
    render() {
        return (<div>{this.props.children}</div>);
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/pages/Proveedores/Proveedores.jsx
 **/